// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"198":"462f0e6d","426":"4e2d6741","481":"baeac206","553":"cfc13ed2","973":"7249518c"}[chunkId] + ".css";
};